import { Modal } from "antd-mobile";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { IMAGE_PREFIX_URL } from "../../../../utils/constants";
export default function usePayingModal() {
  const intl = useIntl()
  const show = ({ onConfrim = () => {}, info = {},cost='' }) => {
    console.log("info", info);
    
    return Modal.show({
      title: intl.formatMessage({id:'pages.shop.paying_modal.title',defaultMessage:"支出帳戶中"}),
      bodyClassName: "runbit_modal",
      showCloseButton: true,
      actions: [
       
      ],
      closeOnAction: false,
      content: <PayingModal info={info} cost={cost} intl={intl}/>,
    });
  };
  return {
    show,
  };
}

function PayingModal({ info, cost, intl}) {
  return (
    <div className="text-center">
      <Image
        src={IMAGE_PREFIX_URL + "/images/" + info.cover}
        alt={"cardImage"}
      />
      <Detail>{intl.formatMessage({id:'pages.shop.paying_modal.content_1',defaultMessage:"交易正在打包，"})} <br/>{intl.formatMessage({id:'pages.shop.paying_modal.content_2',defaultMessage:"您将很快收到您的装备"})}</Detail>
      <Flex justify="between" className="mb-15">
        <Label>Cost</Label>
        <Value>{cost}</Value>
      </Flex>
    </div>
  );
}

const Flex = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.justify === "between" ? "space-between" : ""};
`;
const Label = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.4rem;
  color: #969696;
`;

const Value = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.4rem;

  color: #0b0b0b;
`;

const Image = styled.img`
  height: 11.0rem;

  width: auto;
  margin: auto;
`;

const Detail = styled.div`
  background: #f4f5f6;
  box-shadow: .0rem .0rem 2px rgba(0, 0, 0, 0.08);
  border-radius: 1.6rem;
  padding: 1.0rem 4.0rem;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.8rem;
  margin: 2.0rem auto;
  color: #969696;
`;
